module.exports = __webpack_public_path__ + "img/w3_trash_dark.b6b9861f.png";